import emailService from '../../../services/email.service'
import userService from "../../../services/user.service";
import {mailServerService} from "../../../services/mailServer.service";

export default {
    async getListMailBox({dispatch, commit}, data) {
        return await emailService.getListMailBox(data)
            .then(response => {
                if (response.success && response.data) {
                    commit('SET_MAIL_BOX', response.data)
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    commit('SET_MAIL_BOX', [])
                    dispatch("alertError", response.message, { root: true });
                }

            }).catch(error =>{
                commit('SET_MAIL_BOX', [])
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async updateDisplayOrder({dispatch, commit}, data) {
        return await userService.updateDisplayOrder(data)
            .then(() => {}).catch(error =>{
                console.log(error)
            })
    },
    async getListMailBoxSend({dispatch, commit}, data) {
        return await emailService.getListMailBoxSend(data)
            .then(response => {
                if (response.success && response.data) {
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }

            }).catch(error =>{
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async getMailReceive({ dispatch, commit }, data) {
        commit('SET_CURRENT_MAIL_BOX_SELECT', data.mailBox)
        return await emailService.getMailReceive(data)
            .then(response => {
                if (response.success && response.data) {
                    const listMailReceiveData = response.data.data
                    commit("SET_LIST_MAIL_RECEIVED", listMailReceiveData)
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_MAIL_RECEIVED", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_MAIL_RECEIVED", [])
                // dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async getMailSendBulk({ dispatch, commit }, data) {
        commit('SET_CURRENT_MAIL_BOX_SELECT', data.mailBox)
        return await emailService.getMailReceive(data)
            .then(response => {
                if (response.success && response.data) {
                    const listMailReceiveData = response.data.data
                    commit("SET_LIST_MAIL_RECEIVED", listMailReceiveData)
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_MAIL_RECEIVED", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_MAIL_RECEIVED", [])
                // dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },

    async getListUserDataSelect({ dispatch, commit }, data) {
        return await userService.getListUserSelect(data)
            .then(response => {
                if (response.success && response.data) {
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error => {
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    
    async getListMailServerSentUser({ dispatch, commit }, data) {
        return await mailServerService.getListMailServerSentUser()
            .then(response => {
                if (response.success && response.data) {
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error => {
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async updateMailReceived({ dispatch, commit }, data) {
        return await emailService.updateMailReceived(data)
        .then(response => {
            if (response.status  || response.success) {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data);
            } else {
                dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
            }
        }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        })
    },   
    async updateIsReadMailReceived({ dispatch, commit }, data) {
        return await emailService.updateIsReadMailReceived(data)
        .then(response => {
            if (response.status  || response.success) {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data);
            } else {
                dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
            }
        }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        })
    },
    async updateMailReceivedDetail({ dispatch, commit }, data) {
        return await emailService.updateMailReceivedDetail(data)
        .then(response => {
            if (response.status  || response.success) {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data);
            } else {
                // dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.reject(typeof response.message == 'object' ? response.message[0]:response.message)
            }
        }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        })
    },
    async updateMailReceivedUser({ dispatch, commit }, data) {
        return await emailService.updateMailReceivedDetail(data)
        .then(response => {
            if (response.status  || response.success) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(typeof response.message == 'object' ? response.message[0]:response.message)
            }
        }).catch(error => {
            return Promise.reject(false);
        })
    },
    
    async getStatisticMailReceiveState({ dispatch, commit }) {
        return await emailService.getStatisticMailReceiveState()
        .then(response =>{
            if (response.status || response.success) return Promise.resolve(response.data);
            else dispatch("alertError", response.message, { root: true });
        })
        .catch(error =>{
            dispatch("alertError", error, { root: true });
        })
    },

    getReceiveMailDetail({ dispatch, commit }, data) {
        return emailService.getReceiveMailDetail(data).then(
            response => {
                if(!response) return;
                return Promise.resolve(response.data);
            },
            error => {
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            }
        );
    },    
    
    getListThread({ dispatch, commit }, data) {
        return emailService.getListThread(data).then(
            response => {
                if(!response) return;
                return Promise.resolve(response.data);
            },
            error => {
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            }
        );
    },

    downloadAttachment({dispatch, commit}, data) {
        return emailService.downloadAttachment(data).then(
          response => {
            return Promise.resolve(response.data);
          },
          error => {
            dispatch("alertError", error, {root: true});
            return Promise.reject(false);
          }
        );
    },
    clearSearchFilter({commit}){
        commit('CLEAR_SERACH_FILTER')
    },
    async getListCC({dispatch, commit}, data) {
      return emailService.getListCC(data).then(
        response => {
          return Promise.resolve(response.data);
        },
        error => {
          dispatch("alertError", error, {root: true});
          return Promise.reject(false);
        }
      )
    },
    async getListTo({dispatch, commit}, data) {
      return emailService.getListTo(data).then(
        response => {
          return Promise.resolve(response.data);
        },
        error => {
          dispatch("alertError", error, {root: true});
          return Promise.reject(false);
        }
      )
    },
    async refetchMailReceive({ dispatch, commit }, data) {
      commit('SET_CURRENT_MAIL_BOX_SELECT', data.mailBox)
      return await emailService.refetchMailReceive(data)
        .then(response => {
          if (response.success && response.data) {
              dispatch("alertSuccess", response.message[0], { root: true });
              return Promise.resolve(response.data);
          } else {
              dispatch("alertError", response.message[0], { root: true });
              return Promise.resolve(response.message[0]);
          }
        }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        }
      )
    },

    setMode ({dispatch ,commit}){
        commit('SET_MODE');
    },

    async setUserReadOnly({dispatch, commit}, data) {
        return emailService.setUserReadOnly(data).then(
          response => {
            return Promise.resolve(response.data);
          },
          error => {
            dispatch("alertError", error, {root: true});
            return Promise.reject(false);
          }
        )
      },
    
    async getDataExportCSV({ dispatch, commit }, data) {
        return await emailService.getDataExportCSV(data)
        .then(response => {
            if (response.success && response.data) {
                return Promise.resolve(response.data);
            } else {
                dispatch("alertError", response.message, { root: true });
            }
        }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        })
    },

    async setMailUserName({ dispatch, commit }, data) {
        return await emailService.setMailUserName(data)
        .then(response => {
            if (response.success && response.data) {
                dispatch("alertSuccess", response.message, { root: true });
                return Promise.resolve(response.data);
            } else {
                dispatch("alertError", response.message, { root: true });
            }  
        }).catch(error => {
            console.log(error)
            dispatch("alertError", error.message, { root: true });
            return Promise.reject(false);
        })
    },

    async deleteMailReceive({ dispatch, commit }, data){
        return emailService.deleteMailReceive(data)
            .then(response => {
                if (response.success && response.data) {
                    dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error => {
                dispatch("alertError", error, {root: true});
                return Promise.reject(false);
            })
    },
}